import { useQuery as r } from "@tanstack/react-query";
import { customInstance as n } from "../../mutator/custom-instance.es.js";
const y = (e, u, t) => n({
  url: `/api/booking_requests/${e}/status`,
  method: "GET",
  signal: t
}, u), q = (e) => [`/api/booking_requests/${e}/status`], c = (e, u) => {
  const {
    query: t,
    request: s
  } = u ?? {};
  return {
    queryKey: (t == null ? void 0 : t.queryKey) ?? q(e),
    queryFn: ({
      signal: o
    }) => y(e, s, o),
    enabled: !!e,
    ...t
  };
};
function k(e, u) {
  const t = c(e, u), s = r(t);
  return s.queryKey = t.queryKey, s;
}
export {
  y as getBookingRequestStatus,
  q as getGetBookingRequestStatusQueryKey,
  c as getGetBookingRequestStatusQueryOptions,
  k as useGetBookingRequestStatus
};
